import Block from '../../common.blocks/block'

export default class Product extends Block {
	static title = 'product'

	static hoverImagesBound = false

	constructor($el) {
		super($el)

		Product.bindHoverImages()

		this.anchor = this.$el.findElement('image-placeholder')

		const scrollItem =
			'.product__image-placeholder[data-product-id="' +
			localStorage.getItem('redirectedProduct') +
			'"]'
		if (
			localStorage.getItem('redirectedProduct') &&
			this.$el.hasModifier('overview')
		) {
			if ($(scrollItem).length > 0) {
				const position = $(scrollItem).offset().top - 150
				$('html, body').animate({ scrollTop: position }, 1000)
				localStorage.removeItem('redirectedProduct')

				$(window).bind('mousewheel', function () {
					$('html, body').stop()
				})
			}
		}

		this.anchor.on('click', () => {
			localStorage.setItem('redirectedProduct', this.anchor.data('productId'))
		})
	}

	static bindHoverImages() {
		if (Product.hoverImagesBound) {
			return
		}

		Product.hoverImagesBound = true

		$(document).on('mouseenter focusin', '.product', function () {
			$(this)
				.findElement('image--second')
				.filter('[data-src]')
				.each(function () {
					const $image = $(this)

					$image.on('load', () =>
						$image.closest('.product').addModifier('hover-image-ready'),
					)

					if (this.dataset.srcset) {
						this.srcset = this.dataset.srcset
						this.removeAttribute('data-srcset')
					}

					this.src = this.dataset.src
					this.removeAttribute('data-src')
				})
		})
	}
}
